import { SectionCard } from 'components/SectionCard';
import Stack from 'components/Stack';
import styled from 'styled-components';

const NoDataSectionCard = styled(SectionCard)`
    padding: 4.5rem 1.25rem;
`;
const InnerNoDataSection = styled(Stack).attrs(
    ({ $direction = 'column', $space = '1.125rem' }) => ({
        $direction,
        $space,
    }),
)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const NoDataH1 = styled.h1`
    margin: 0;
    font-family: ${({ theme }) => theme.style_primary};
    font-size: 1.5rem;
    font-weight: 700;
    color: ${({ theme }) => theme.gray_900};
    text-transform: capitalize;
`;

const NoDataMessage = styled.p`
    font-family: ${({ theme }) => theme.style_primary};
    font-size: 0.875rem;
    font-weight: 500;
    color: ${({ theme }) => theme.gray_800};

    a {
        color: ${({ theme }) => theme.purple_1};
    }

    a:hover {
        color: ${({ theme }) => theme.purple};
        text-decoration: underline;
    }
`;

function NoDataSection({ heading, message }) {
    return (
        <NoDataSectionCard>
            <InnerNoDataSection>
                <NoDataH1>{heading}</NoDataH1>
                <NoDataMessage>{message}</NoDataMessage>
            </InnerNoDataSection>
        </NoDataSectionCard>
    );
}

export default NoDataSection;
